export const inboxs = [
    {
        id: 1,
        name: null,
        phone: "229 69 67 09 05",
        picture_url: null,
        agent_treatment_id: 2,
        agent_treatment: {
            id: 2,
            firstname: "Albericq",
            lastname: "KPONSO",
            color: "darkred",
            email: 'albericq.kponso@alibora.com',
            profil: "https://picsum.photos/id/64/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                content: "Bonjour",
                hours: "19:14",
                dateSend: "2025-02-12",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: false,
                isFile: false,
                content: "J'espère que vous allez bien.",
                hours: "19:16",
                dateSend: "2025-02-12",
                agent_id: null,
                agent: null
            },
            {
                id: 3,
                selfMessage: true,
                isFile: false,

                content: "Bonsoir monsieur, oui je me porte bien et chez vous ?",
                hours: "19:20",
                dateSend: "2025-02-12",
                agent_id: 1,
                agent: {
                    id: 1,
                    firstname: "Keira",
                    lastname: "BALLO",
                    color: "skyblue",
                    email: 'kei.ballo@alibora.com',
                    profil: "https://picsum.photos/id/23/4326/2884",
                }
            },
            {
                id: 4,
                selfMessage: false,
                isFile: false,
                content: "Bonsoir, j'aimerais savoir où je peux récupérer ma carte biométrique ?",
                hours: "12:20",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 5,
                selfMessage: true,
                isFile: false,
                content: "Je vous ai envoyé le document demandé.",
                hours: "12:20",
                dateSend: "2025-02-19",
                agent_id: 2,
                agent: {
                    id: 2,
                    firstname: "Albericq",
                    lastname: "KPONSO",
                    color: "darkred",
                    email: 'albericq.kponso@alibora.com',
                    profil: "https://picsum.photos/id/64/4326/2884",
                }
            },
            {
                id: 6,
                selfMessage: false,
                isFile: true,
                content: "Veuillez consulter le fichier joint.",
                hours: "13:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 7,
                selfMessage: true,
                isFile: false,
                content: "Je n'ai pas encore reçu la confirmation de votre part.",
                hours: "14:00",
                dateSend: "2025-02-19",
                agent_id: 2,
                agent: {
                    id: 2,
                    firstname: "Albericq",
                    lastname: "KPONSO",
                    color: "darkred",
                    email: 'albericq.kponso@alibora.com',
                    profil: "https://picsum.photos/id/64/4326/2884",
                }
            },
            {
                id: 8,
                selfMessage: false,
                isFile: false,
                content: "Bonjour, avez-vous reçu mon email ?",
                hours: "15:10",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 9,
                selfMessage: false,
                isFile: true,
                content: "Voici le rapport que vous m'avez demandé.",
                hours: "16:05",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 10,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Je vais vérifier cela et revenir vers vous.",
                hours: "16:45",
                dateSend: "2025-02-19",
                agent_id: 2,
                agent: {
                    id: 2,
                    firstname: "Albericq",
                    lastname: "KPONSO",
                    color: "darkred",
                    email: 'albericq.kponso@alibora.com',
                    profil: "https://picsum.photos/id/64/4326/2884",
                }
            },
        ]
    },
    {
        id: 2,
        name: null,
        phone: "229 51 80 07 15",
        picture_url: null,
        agent_treatment_id: 1,
        agent_treatment: {
            id: 1,
            firstname: "Keira",
            lastname: "BALLO",
            color: "yellow",
            email: 'kei.ballo@alibora.com',
            profil: "https://picsum.photos/id/23/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                content: "Salut, on se voit à 14h au café comme prévu ?",
                hours: "12:14",
                dateSend: "2025-02-12",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: true,
                isFile: false,
                content: "Oui je suis pour, n'oublie pas d'apporter mon chargeur.",
                hours: "19:16",
                dateSend: "2025-02-12",
                agent_id: 1,
                agent: {
                    id: 1,
                    firstname: "Keira",
                    lastname: "BALLO",
                    color: "yellow",
                    email: 'kei.ballo@alibora.com',
                    profil: "https://picsum.photos/id/23/4326/2884",
                }
            },
            {
                id: 3,
                selfMessage: true,
                isFile: false,
                content: "Et aussi du lait, je dois prendre mon médicament avec.",
                hours: "19:20",
                dateSend: "2025-02-12",
                agent_id: 1,
                agent: {
                    id: 1,
                    firstname: "Keira",
                    lastname: "BALLO",
                    color: "yellow",
                    email: 'kei.ballo@alibora.com',
                    profil: "https://picsum.photos/id/23/4326/2884",
                }
            },
            {
                id: 4,
                selfMessage: false,
                isFile: false,
                content: "D'accord, c'est compris, tu sais que le CC a finalement envoyé les tuyaux ?",
                hours: "12:20",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 5,
                selfMessage: true,
                isFile: false,
                content: "Vraiment, incroyable !",
                hours: "12:20",
                dateSend: "2025-02-19",
                agent_id: 1,
                agent: {
                    id: 1,
                    firstname: "Keira",
                    lastname: "BALLO",
                    color: "yellow",
                    email: 'kei.ballo@alibora.com',
                    profil: "https://picsum.photos/id/23/4326/2884",
                }
            },
            {
                id: 6,
                selfMessage: false,
                isFile: true,
                content: "Veuillez consulter le fichier joint.",
                hours: "14:00",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 7,
                selfMessage: true,
                isFile: false,
                content: "Merci, je vais le vérifier.",
                hours: "15:20",
                dateSend: "2025-02-19",
                agent_id: 1,
                agent: {
                    id: 1,
                    firstname: "Keira",
                    lastname: "BALLO",
                    color: "yellow",
                    email: 'kei.ballo@alibora.com',
                    profil: "https://picsum.photos/id/23/4326/2884",
                }
            },
            {
                id: 8,
                selfMessage: false,
                isFile: false,
                content: "Quand pouvons-nous discuter de la réunion ?",
                hours: "16:40",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 9,
                selfMessage: false,
                isFile: true,
                content: "Voici la présentation demandée.",
                hours: "17:10",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 10,
                selfMessage: true,
                isRead: true,
                isSend: true,
                isFile: false,
                content: "D'accord, je vous tiendrai au courant.",
                hours: "18:00",
                dateSend: "2025-02-19",
                agent_id: 1,
                agent: {
                    id: 1,
                    firstname: "Keira",
                    lastname: "BALLO",
                    color: "yellow",
                    email: 'kei.ballo@alibora.com',
                    profil: "https://picsum.photos/id/23/4326/2884",
                }
            }
        ]
    },
    {
        id: 3,
        name: null,
        phone: "229 66 58 99 77",
        picture_url: null,
        agent_treatment_id: 3,
        agent_treatment: {
            id: 3,
            firstname: "Alibora",
            lastname: "SARL",
            color: "green",
            email: 'alibora.sarl@alibora.com',
            profil: "https://picsum.photos/id/45/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                content: "Pouvez-vous confirmer la réception du paiement ?",
                hours: "09:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: true,
                isFile: false,
                content: "Oui, j'ai bien reçu le paiement.",
                hours: "10:00",
                dateSend: "2025-02-19",
                agent_id: 3,
                agent: {
                    id: 3,
                    firstname: "Alibora",
                    lastname: "SARL",
                    color: "green",
                    email: 'alibora.sarl@alibora.com',
                    profil: "https://picsum.photos/id/45/4326/2884",
                }
            },
            {
                id: 3,
                selfMessage: false,
                isFile: false,
                content: "Merci beaucoup pour votre réactivité.",
                hours: "10:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 4,
                selfMessage: false,
                isFile: false,
                content: "Pouvez-vous me dire l'heure exacte de la réunion ?",
                hours: "11:15",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 5,
                selfMessage: true,
                isFile: false,
                content: "La réunion est prévue pour 15h aujourd'hui.",
                hours: "11:50",
                dateSend: "2025-02-19",
                agent_id: 3,
                agent: {
                    id: 3,
                    firstname: "Alibora",
                    lastname: "SARL",
                    color: "green",
                    email: 'alibora.sarl@alibora.com',
                    profil: "https://picsum.photos/id/45/4326/2884",
                }
            },
            {
                id: 6,
                selfMessage: false,
                isFile: false,
                content: "C'est noté, à tout à l'heure.",
                hours: "12:05",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 7,
                selfMessage: true,
                isFile: false,
                content: "Parfait, à tout à l'heure.",
                hours: "12:40",
                dateSend: "2025-02-19",
                agent_id: 3,
                agent: {
                    id: 3,
                    firstname: "Alibora",
                    lastname: "SARL",
                    color: "green",
                    email: 'alibora.sarl@alibora.com',
                    profil: "https://picsum.photos/id/45/4326/2884",
                }
            },
            {
                id: 8,
                selfMessage: false,
                isFile: true,
                content: "Voici le document que vous m'avez demandé.",
                hours: "13:10",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 9,
                selfMessage: true,
                isFile: false,
                content: "Je vais vérifier ce document.",
                hours: "13:40",
                dateSend: "2025-02-19",
                agent_id: 3,
                agent: {
                    id: 3,
                    firstname: "Alibora",
                    lastname: "SARL",
                    color: "green",
                    email: 'alibora.sarl@alibora.com',
                    profil: "https://picsum.photos/id/45/4326/2884",
                }
            },
            {
                id: 10,
                selfMessage: false,
                isFile: false,
                isRead: false,
                isSend: true,
                content: "Merci pour l'envoi, je reviendrai vers vous.",
                hours: "14:00",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            }
        ]
    },
    {
        id: 4,
        name: null,
        phone: "229 91 80 22 65",
        picture_url: null,
        agent_treatment_id: 4,
        agent_treatment: {
            id: 4,
            firstname: "Patrice",
            lastname: "TALON",
            color: "blue",
            email: 'patrice.talon@alibora.com',
            profil: "https://picsum.photos/id/13/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                content: "Merci pour la confirmation, j'ai bien reçu le document.",
                hours: "10:00",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: true,
                isFile: false,
                content: "De rien, je vous en prie.",
                hours: "10:30",
                dateSend: "2025-02-19",
                agent_id: 4,
                agent: {
                    id: 4,
                    firstname: "Patrice",
                    lastname: "TALON",
                    color: "blue",
                    email: 'patrice.talon@alibora.com',
                    profil: "https://picsum.photos/id/13/4326/2884",
                }
            },
            {
                id: 3,
                selfMessage: false,
                isFile: false,
                content: "Je voulais savoir si vous avez reçu mon message précédent.",
                hours: "11:00",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 4,
                selfMessage: true,
                isFile: false,
                content: "Oui, je viens de le voir.",
                hours: "11:30",
                dateSend: "2025-02-19",
                agent_id: 4,
                agent: {
                    id: 4,
                    firstname: "Patrice",
                    lastname: "TALON",
                    color: "blue",
                    email: 'patrice.talon@alibora.com',
                    profil: "https://picsum.photos/id/13/4326/2884",
                }
            },
            {
                id: 5,
                selfMessage: false,
                isFile: false,
                content: "Pouvez-vous m'envoyer la documentation sur le projet ?",
                hours: "12:00",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 6,
                selfMessage: true,
                isFile: false,
                content: "Je vous enverrai cela dans quelques minutes.",
                hours: "12:30",
                dateSend: "2025-02-19",
                agent_id: 4,
                agent: {
                    id: 4,
                    firstname: "Patrice",
                    lastname: "TALON",
                    color: "blue",
                    email: 'patrice.talon@alibora.com',
                    profil: "https://picsum.photos/id/13/4326/2884",
                }
            },
            {
                id: 7,
                selfMessage: false,
                isFile: true,
                content: "Voici la documentation demandée.",
                hours: "13:10",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 8,
                selfMessage: true,
                isFile: false,
                content: "Merci, je vais la consulter.",
                hours: "13:40",
                dateSend: "2025-02-19",
                agent_id: 4,
                agent: {
                    id: 4,
                    firstname: "Patrice",
                    lastname: "TALON",
                    color: "blue",
                    email: 'patrice.talon@alibora.com',
                    profil: "https://picsum.photos/id/13/4326/2884",
                }
            },
            {
                id: 9,
                selfMessage: false,
                isFile: false,
                content: "Je reviendrai vers vous après la lecture.",
                hours: "14:10",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 10,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Très bien, je vous tiens informé.",
                hours: "14:40",
                dateSend: "2025-02-19",
                agent_id: 4,
                agent: {
                    id: 4,
                    firstname: "Patrice",
                    lastname: "TALON",
                    color: "blue",
                    email: 'patrice.talon@alibora.com',
                    profil: "https://picsum.photos/id/13/4326/2884",
                }
            }
        ]
    },
    {
        id: 5,
        name: null,
        phone: "229 81 29 53 44",
        picture_url: null,
        agent_treatment_id: 5,
        agent_treatment: {
            id: 5,
            firstname: "Mathieu",
            lastname: "KEREKOU",
            color: "orange",
            email: 'mathieu.kerekou@alibora.com',
            profil: "https://picsum.photos/id/56/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Je vous ai envoyé les documents nécessaires.",
                hours: "08:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Merci pour l'envoi.",
                hours: "09:00",
                dateSend: "2025-02-19",
                agent_id: 5,
                agent: {
                    id: 5,
                    firstname: "Mathieu",
                    lastname: "KEREKOU",
                    color: "orange",
                    email: 'mathieu.kerekou@alibora.com',
                    profil: "https://picsum.photos/id/56/4326/2884",
                }
            },
            {
                id: 3,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Pouvez-vous m'envoyer la facture ?",
                hours: "09:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 4,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Je vais vous l'envoyer maintenant.",
                hours: "10:00",
                dateSend: "2025-02-19",
                agent_id: 5,
                agent: {
                    id: 5,
                    firstname: "Mathieu",
                    lastname: "KEREKOU",
                    color: "orange",
                    email: 'mathieu.kerekou@alibora.com',
                    profil: "https://picsum.photos/id/56/4326/2884",
                }
            },
            {
                id: 5,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "D'accord, merci pour votre réactivité.",
                hours: "10:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 6,
                selfMessage: true,
                isFile: true,
                isRead: true,
                isSend: true,
                content: "Voici la facture.",
                hours: "11:00",
                dateSend: "2025-02-19",
                agent_id: 5,
                agent: {
                    id: 5,
                    firstname: "Mathieu",
                    lastname: "KEREKOU",
                    color: "orange",
                    email: 'mathieu.kerekou@alibora.com',
                    profil: "https://picsum.photos/id/56/4326/2884",
                }
            },
            {
                id: 7,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Merci pour l'envoi de la facture.",
                hours: "11:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 8,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Avec plaisir !",
                hours: "12:00",
                dateSend: "2025-02-19",
                agent_id: 5,
                agent: {
                    id: 5,
                    firstname: "Mathieu",
                    lastname: "KEREKOU",
                    color: "orange",
                    email: 'mathieu.kerekou@alibora.com',
                    profil: "https://picsum.photos/id/56/4326/2884",
                }
            },
            {
                id: 9,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Je reviendrai vers vous après avoir vérifié les informations.",
                hours: "12:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 10,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Très bien, je reste disponible si besoin.",
                hours: "13:00",
                dateSend: "2025-02-19",
                agent_id: 5,
                agent: {
                    id: 5,
                    firstname: "Mathieu",
                    lastname: "KEREKOU",
                    color: "orange",
                    email: 'mathieu.kerekou@alibora.com',
                    profil: "https://picsum.photos/id/56/4326/2884",
                }
            }
        ]
    },
    {
        id: 11,
        name: 'Alby KPS',
        picture_url: 'https://picsum.photos/id/1/200/300',
        phone: "229 67 12 34 56",
        agent_treatment_id: null,
        agent_treatment: null,
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Bonjour, j'aimerais savoir comment procéder pour récupérer ma carte d'identité ?",
                hours: "08:30",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            },

            {
                id: 3,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Est-ce qu'il faut un certificat de naissance pour la demande ?",
                hours: "08:50",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            },

            {
                id: 5,
                selfMessage: false,
                isFile: false,
                isRead: false,
                isSend: true,
                content: "Merci pour l'information, je vais préparer les documents.",
                hours: "09:15",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            }
        ]
    },
    {
        id: 12,
        phone: "229 77 45 89 12",
        agent_treatment_id: 5,
        name: null,
        picture_url: null,
        agent_treatment: {
            id: 5,
            firstname: "Mathieu",
            lastname: "KEREKOU",
            color: "orange",
            email: 'mathieu.kerekou@alibora.com',
            profil: "https://picsum.photos/id/56/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Bonjour, je souhaite savoir comment demander un passeport.",
                hours: "10:00",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Boqnjour, vous devez remplir un formulaire en ligne et fournir une copie de votre carte d'identité.",
                hours: "10:15",
                dateSend: "2025-02-18",
                agent_id: 5,
                agent: {
                    id: 5,
                    firstname: "Mathieu",
                    lastname: "KEREKOU",
                    color: "orange",
                    email: 'mathieu.kerekou@alibora.com',
                    profil: "https://picsum.photos/id/56/4326/2884",
                }
            },
            {
                id: 3,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Est-ce qu'il y a des frais pour la demande ?",
                hours: "10:30",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            },
            {
                id: 4,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Oui, des frais de traitement sont exigés. Vous les trouverez sur le site officiel.",
                hours: "10:45",
                dateSend: "2025-02-18",
                agent_id: 5,
                agent: {
                    id: 5,
                    firstname: "Mathieu",
                    lastname: "KEREKOU",
                    color: "orange",
                    email: 'mathieu.kerekou@alibora.com',
                    profil: "https://picsum.photos/id/56/4326/2884",
                }
            },
            {
                id: 5,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Merci, je vais procéder à la demande en ligne.",
                hours: "11:00",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            }
        ]
    },
    {
        id: 13,
        phone: "229 91 67 43 21",
        agent_treatment_id: 2,
        name: null,
        picture_url: null,
        agent_treatment: {
            id: 2,
            firstname: "Albericq",
            lastname: "KPONSO",
            color: "darkred",
            email: 'albericq.kponso@alibora.com',
            profil: "https://picsum.photos/id/64/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Bonjour, je souhaite savoir comment récupérer ma carte d'identité après l'avoir demandée.",
                hours: "08:00",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Bonjour, il vous suffit de venir à la préfecture avec votre reçu de demande et votre photo d'identité.",
                hours: "08:10",
                dateSend: "2025-02-18",
                agent_id: 2,
                agent: {
                    id: 2,
                    firstname: "Albericq",
                    lastname: "KPONSO",
                    color: "darkred",
                    email: 'albericq.kponso@alibora.com',
                    profil: "https://picsum.photos/id/64/4326/2884",
                }
            },
            {
                id: 3,
                selfMessage: false,
                isRead: true,
                isSend: true,
                isFile: false,
                content: "Merci pour l'information. Est-ce que je peux envoyer un tiers à ma place ?",
                hours: "08:30",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            },
            {
                id: 4,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Oui, votre tiers peut venir avec une lettre d'autorisation signée par vos soins.",
                hours: "08:45",
                dateSend: "2025-02-18",
                agent_id: 2,
                agent: {
                    id: 2,
                    firstname: "Albericq",
                    lastname: "KPONSO",
                    color: "darkred",
                    email: 'albericq.kponso@alibora.com',
                    profil: "https://picsum.photos/id/64/4326/2884",
                }
            },
            {
                id: 5,
                selfMessage: false,
                isRead: false,
                isSend: false,
                isFile: false,
                content: "D'accord, je vais faire ça. Merci pour votre aide.",
                hours: "09:00",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            }
        ]
    },
    {
        id: 14,
        phone: "229 53 72 89 67",
        agent_treatment_id: 4,
        name: null,
        picture_url: null,
        agent_treatment: {
            id: 4,
            firstname: "Alibora",
            lastname: "SARL",
            color: "green",
            email: 'alibora.sarl@alibora.com',
            profil: "https://picsum.photos/id/78/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                content: "Bonsoir, je voudrais savoir quel est le délai pour recevoir un passeport après la demande.",
                hours: "18:00",
                dateSend: "2025-02-18",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Bonsoir, le délai est généralement de 3 à 4 semaines après l'enregistrement de votre demande.",
                hours: "18:15",
                dateSend: "2025-02-18",
                agent_id: 4,
                agent: {
                    id: 4,
                    firstname: "Alibora",
                    lastname: "SARL",
                    color: "green",
                    email: 'alibora.sarl@alibora.com',
                    profil: "https://picsum.photos/id/78/4326/2884",
                }
            },
            {
                id: 3,
                selfMessage: true,
                isFile: false,
                isRead: false,
                isSend: true,
                content: "C'est parfait, merci pour la réponse rapide.",
                hours: "18:30",
                dateSend: "2025-02-18",
                agent_id: 4,
                agent: {
                    id: 4,
                    firstname: "Alibora",
                    lastname: "SARL",
                    color: "green",
                    email: 'alibora.sarl@alibora.com',
                    profil: "https://picsum.photos/id/78/4326/2884",
                }
            }
        ]
    },
    {
        id: 15,
        phone: "229 60 45 23 45",
        agent_treatment_id: 5,
        name: null,
        picture_url: null,
        agent_treatment: {
            id: 5,
            firstname: "Mathieu",
            lastname: "KEREKOU",
            color: "orange",
            email: 'mathieu.kerekou@alibora.com',
            profil: "https://picsum.photos/id/56/4326/2884",
        },
        messages: [
            {
                id: 1,
                selfMessage: false,
                isFile: false,
                isRead: false,
                isSend: false,
                content: "Bonjour, comment faire pour renouveler ma carte d'identité ?",
                hours: "09:00",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            },
            {
                id: 2,
                selfMessage: true,
                isFile: false,
                isRead: true,
                isSend: true,
                content: "Bonjour, vous devez présenter une copie de votre ancienne carte et une photo d'identité récente.",
                hours: "09:15",
                dateSend: "2025-02-19",
                agent_id: 5,
                agent: {
                    id: 5,
                    firstname: "Mathieu",
                    lastname: "KEREKOU",
                    color: "orange",
                    email: 'mathieu.kerekou@alibora.com',
                    profil: "https://picsum.photos/id/56/4326/2884",
                }
            },
            {
                id: 3,
                selfMessage: false,
                isRead: false,
                isSend: false,
                isFile: false,
                content: "D'accord, merci beaucoup.",
                hours: "09:30",
                dateSend: "2025-02-19",
                agent_id: null,
                agent: null
            }
        ]
    }
];

export const agents = [
    {
        id: 2,
        firstname: "Albericq",
        lastname: "KPONSO",
        color: "darkred",
        email: 'albericq.kponso@alibora.com',
        profil: "https://picsum.photos/id/64/4326/2884",
        message_count: 0,
    }, {
        id: 5,
        firstname: "Mathieu",
        lastname: "KEREKOU",
        color: "orange",
        email: 'mathieu.kerekou@alibora.com',
        profil: "https://picsum.photos/id/56/4326/2884",
        message_count: 20,
    }, {
        id: 4,
        firstname: "Patrice",
        lastname: "TALON",
        color: "blue",
        email: 'patrice.talon@alibora.com',
        profil: "https://picsum.photos/id/13/4326/2884",
        message_count: 0,
    }, {
        id: 3,
        firstname: "Alibora",
        lastname: "SARL",
        color: "green",
        email: 'alibora.sarl@alibora.com',
        profil: "https://picsum.photos/id/45/4326/2884",
        message_count: 0,
    }, {
        id: 1,
        firstname: "Keira",
        lastname: "BALLO",
        color: "yellow",
        email: 'kei.ballo@alibora.com',
        profil: "https://picsum.photos/id/23/4326/2884",
        message_count: 7,
    },
]

